import { InformationCircleIcon } from '@heroicons/react/24/solid';

import { Checkbox } from '@/components/form/Checkbox';
import { Tooltip } from '@/components/Tooltip';

interface OutputSettingsProps {
  largeArtifact: boolean;
  setLargeArtifact: (value: boolean) => void;
}

/**
 * OutputSettings - Configuration for capability output settings
 *
 * Allows users to enable large scan artifacts that will be stored
 * for manual review and available to download from the Jobs page.
 */
export function OutputSettings({
  largeArtifact,
  setLargeArtifact,
}: OutputSettingsProps) {
  return (
    <div className="mb-8">
      <h4 className="text-md text-chariot-text-primary mb-4 font-medium">
        Output Settings
      </h4>
      <div className="flex items-center gap-2 select-none">
        <Checkbox
          name="large-artifact"
          value={largeArtifact ? 'true' : 'false'}
          onChange={e => setLargeArtifact(Boolean(e.target.value))}
          label="Enable large scan artifacts"
        />
        <Tooltip title="Large scan artifacts will be stored for manual review and available to download from Jobs page.">
          <InformationCircleIcon className="text-chariot-stroke size-4" />
        </Tooltip>
      </div>
    </div>
  );
}
